module.exports = __webpack_public_path__ + "static/media/mito04.eff6af83.jpg";